import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import { firebaseConfig } from "./config";

firebase.initializeApp(firebaseConfig);
const firebaseDb = firebase.firestore();
const firebaseAuth = firebase.auth();

export { firebase, firebaseDb, firebaseAuth, firebaseConfig };
